import React, { useContext } from "react"
// import Img from "gatsby-background-image"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"
// import { motion, AnimatePresence } from "framer-motion"
import styled, { css } from "styled-components"

import { LayoutContext } from "./layout-context"

const TextureEl = styled.div`
  transition: filter 0.5s;
  ${props =>
    props.invert &&
    css`
      filter: invert(1) contrast(0.9);
    `}
`

const BackgroundTexture = props => {
  const layoutContext = useContext(LayoutContext)

  return (
    <TextureEl
      invert={props.invert !== false && layoutContext.layout === "no-footer"}
    >
      <Img
        style={{ height: "100%" }}
        fluid={props.data.bgImage.childImageSharp.fluid}
      />
    </TextureEl>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        bgImage: file(relativePath: { eq: "images/background-texture.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 50) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `}
    render={data => <BackgroundTexture data={data} {...props} />}
  />
)
